import { Chart } from "primereact/chart";
import { useEffect, useRef, useState } from "react";

function StaticsData(): JSX.Element {
  const [chartData,    setChartData]    = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas  = document.createElement("canvas");
    const ctx     = canvas.getContext("2d");

    const makeGradient = (color1: string, color2: string) => {
      if (!ctx) return color1;
      const g = ctx.createLinearGradient(0, 0, 0, 400);
      g.addColorStop(0,   color1);
      g.addColorStop(1,   color2);
      return g;
    };

    const gradGreen  = makeGradient("rgba(0,168,107,0.35)",  "rgba(0,168,107,0)");
    const gradTeal   = makeGradient("rgba(20,184,166,0.25)", "rgba(20,184,166,0)");
    const gradOrange = makeGradient("rgba(249,115,22,0.25)", "rgba(249,115,22,0)");

    const data = {
      labels: [
        "Ene","Feb","Mar","Abr","May","Jun",
        "Jul","Ago","Sep","Oct","Nov","Dic",
      ],
      datasets: [
        {
          label:           "Transacciones realizadas",
          data:            [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56],
          fill:            true,
          tension:         0.45,
          borderColor:     "#00A86B",
          borderWidth:     2.5,
          backgroundColor: gradGreen,
          pointBackgroundColor:  "#00A86B",
          pointBorderColor:      "#ffffff",
          pointBorderWidth:      2,
          pointRadius:           4,
          pointHoverRadius:      7,
          pointHoverBackgroundColor: "#00A86B",
          pointHoverBorderWidth: 3,
        },
        {
          label:           "Dinero retirado",
          data:            [12, 51, 62, 33, 21, 62, 55, 22, 63, 51, 22, 55],
          fill:            true,
          borderDash:      [6, 4],
          tension:         0.45,
          borderColor:     "#14b8a6",
          borderWidth:     2.5,
          backgroundColor: gradTeal,
          pointBackgroundColor:  "#14b8a6",
          pointBorderColor:      "#ffffff",
          pointBorderWidth:      2,
          pointRadius:           4,
          pointHoverRadius:      7,
          pointHoverBackgroundColor: "#14b8a6",
          pointHoverBorderWidth: 3,
        },
        {
          label:           "Dinero enviado",
          data:            [10, 50, 60, 30, 20, 20, 18, 55, 30, 20, 60, 40],
          fill:            true,
          tension:         0.45,
          borderColor:     "#f97316",
          borderWidth:     2.5,
          backgroundColor: gradOrange,
          pointBackgroundColor:  "#f97316",
          pointBorderColor:      "#ffffff",
          pointBorderWidth:      2,
          pointRadius:           4,
          pointHoverRadius:      7,
          pointHoverBackgroundColor: "#f97316",
          pointHoverBorderWidth: 3,
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      responsive: true,

      animation: {
        duration: 1200,
        easing:   "easeInOutQuart" as const,
        x: {
          type:    "number" as const,
          easing:  "easeInOutQuart" as const,
          duration: 1200,
          from:    NaN, 
        },
        y: {
          type:    "number" as const,
          easing:  "easeInOutBounce" as const,
          duration: 1400,
          from:    500,
        },
      },

      interaction: {
        mode:      "index"     as const,
        intersect: false,
      },

      plugins: {
        legend: {
          position: "top" as const,
          align:    "end"  as const,
          labels: {
            color:      "#6b7280",
            font:       { family: "'Plus Jakarta Sans', sans-serif", size: 12, weight: "600" },
            usePointStyle: true,
            pointStyle:    "circle",
            padding:       20,
            boxWidth:      8,
          },
        },
        tooltip: {
          backgroundColor: "#ffffff",
          titleColor:      "#1a1d23",
          bodyColor:       "#4b5563",
          borderColor:     "#e8eaed",
          borderWidth:     1,
          padding:         12,
          cornerRadius:    10,
          titleFont:       { family: "'Plus Jakarta Sans', sans-serif", size: 13, weight: "700" },
          bodyFont:        { family: "'Plus Jakarta Sans', sans-serif", size: 12 },
          boxPadding:      6,
          usePointStyle:   true,
          callbacks: {
            label: (ctx: any) =>
              `  ${ctx.dataset.label}: ${ctx.parsed.y}`,
          },
        },
      },

      scales: {
        x: {
          grid: {
            color:     "rgba(0,0,0,0.04)",
            drawBorder: false,
          },
          ticks: {
            color: "#9ca3af",
            font:  { family: "'Plus Jakarta Sans', sans-serif", size: 11 },
            maxRotation: 0,
          },
          border: { dash: [4, 4] },
        },
        y: {
          grid: {
            color:     "rgba(0,0,0,0.04)",
            drawBorder: false,
          },
          ticks: {
            color: "#9ca3af",
            font:  { family: "'Plus Jakarta Sans', sans-serif", size: 11 },
            padding: 8,
            stepSize: 20,
          },
          border: { dash: [4, 4] },
          beginAtZero: true,
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  return (
    <div style={{ height: "320px", position: "relative" }}>
      <Chart type="line" data={chartData} options={chartOptions} />
    </div>
  );
}

export default StaticsData;